import gql from 'graphql-tag'

export const BLACKLIST_EMPLOYER = gql`
 mutation(
  $employerId:ID
  $reasonBlacklist: String
  $files:[String]
){  addBlacklist(info:{
    employerId: $employerId
    reasonBlacklist:$reasonBlacklist
	files:$files
  })
  }
    `
export const UPDATE_BLACKLIST_EMPLOYER = gql`
mutation(
$_id:ID
 $employerId:ID
 $reasonBlacklist: String
 $files:[String]
){  updateBlacklist(info:{
	_id:$_id
   employerId: $employerId
   reasonBlacklist:$reasonBlacklist
   files:$files
 })
 }
 `
export const UNBLACKLIST_EMPLOYER = gql`
mutation(
$_id:ID
 $employerId:ID
 $reasonUnblacklist: String
 $files:[String]
){  unBlacklist(info:{
	_id:$_id
   employerId: $employerId
   reasonUnblacklist:$reasonUnblacklist
   files:$files
 })
 }
 `
export const GET_BLACKLIST = gql`
 query(
	$page:Int
	$perPage:Int
	$search:Boolean
){
	get_Blacklist(page:$page perPage:$perPage search:$search){
		info{
			_id
			logo
			companyName
			reasonBlacklist
			reasonUnblacklist
			createdAt
			files
			auth
		}
	}
}
 `

export const GETBYID = gql`
 
 query(
	$_id:ID
){
	getById(_id:$_id){
			_id
			logo
			employerId
			companyName
			reasonBlacklist
			reasonUnblacklist
			createdAt
			files
			auth
	}
}
 `
export const BLACKLISTINFO = gql`
 
 query(
	$employerId:ID
){
	blackListInfo(employerId:$employerId){
			_id
			logo
			employerId
			companyName
			reasonBlacklist
			reasonUnblacklist
			createdAt
			files
			auth
	}
}
 `

export const GRAYLIST = gql`
query(
	$page:Int
	$perPage:Int
	$search:String
){
	grayList(page:$page perPage:$perPage search:$search){
		employers{
		empId
		logo
		companyName
	    grayStatus
		}
		totals
	}
}
 `

export const UNLOCKGRAY = gql`
mutation(
 $employerId:ID
){  unLockGray(info:{
   employerId: $employerId
 })
 }
 `